export default "__VITE_ASSET__CM4xbhuF__"